import React from 'react';

import { NpsFontFace } from '../NpsSurveyModal/styles';

import { StyledModal } from './styles';
import { IGoogleReviewModalProps } from './types';

const GOOGLE_REVIEW_URL = 'https://g.page/r/CTSZ2c0Lo8KyEBM/review';

const GoogleLogo: React.FC = () => (
  <svg className="google-logo" width="46" height="46" viewBox="0 0 48 48" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"
    />
    <path
      fill="#34A853"
      d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z"
    />
    <path
      fill="#FBBC05"
      d="M11.69 28.18c-.44-1.32-.69-2.73-.69-4.18s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24s.85 6.91 2.34 9.88l7.35-5.7z"
    />
    <path
      fill="#EA4335"
      d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z"
    />
  </svg>
);

const StarIcon: React.FC = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 2.5l2.95 5.98 6.6.96-4.775 4.655 1.127 6.573L12 17.56l-5.902 3.108 1.127-6.573L2.45 9.44l6.6-.96L12 2.5z"
      stroke="#ffffff"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const GoogleReviewModal: React.FC<IGoogleReviewModalProps> = ({ visible, onClose }) => {
  const handleReview = () => {
    window.open(GOOGLE_REVIEW_URL, '_blank', 'noopener,noreferrer');
    onClose();
  };

  return (
    <>
      <NpsFontFace />
      <StyledModal
        centered
        visible={visible}
        onCancel={onClose}
        width={470}
        footer={null}
        closable={false}
        maskClosable={false}
        keyboard={false}
        maskStyle={{ background: 'rgba(15, 15, 18, 0.55)', backdropFilter: 'blur(1.5px)' }}
      >
        <button className="close" type="button" aria-label="Fechar" onClick={onClose}>
          ✕
        </button>
        <div className="content">
          <span className="brand">valori</span>
          <p className="thanks">Obrigado pela sua avaliação!</p>
          <h2 className="invite">Que tal também nos avaliar no Google?</h2>
          <GoogleLogo />
          <button className="review" type="button" onClick={handleReview}>
            <StarIcon />
            Avaliar no Google
          </button>
          <button className="later" type="button" onClick={onClose}>
            Agora não
          </button>
        </div>
      </StyledModal>
    </>
  );
};

export default GoogleReviewModal;
